export enum NotificationType {
  Error = 'error',
  Warning = 'warning',
  Success = 'success'
}
